import React from "react";
import { Alert, Box, Typography } from "@mui/material";
import moment from "moment";
import { getStoreClosedDaysOfWeek, isDateAvailable } from "./component/util";

const DAY_MAP = {
  1: "Sunday",
  2: "Monday",
  3: "Tuesday",
  4: "Wednesday",
  5: "Thursday",
  6: "Friday",
  7: "Saturday"
};

export default function StoreAvailabilityCalendar(props) {
  const { storeLocation, date } = props;

  let alert = "";
  if (isDateAvailable(date, storeLocation)) {
    alert = <Alert severity="success">This date is available</Alert>;
  } else {
    alert = <Alert severity="error">This date is not available</Alert>;
  }

  let storeHours = getStoreClosedDaysOfWeek(storeLocation);

  let blockedDates = "";
  if (storeLocation.rules?.date?.block) {
    const soldOutDates = storeLocation.rules.date.block.filter((o) => o >= moment().format("YYYY-MM-DD")).sort();
    if (soldOutDates.length > 0) {
      blockedDates = (
        <Box px={2} py={2} sx={{ border: "1px solid #DEDEDE", borderRadius: "4px" }}>
          <Box sx={{ display: "flex", gap: "10px", overflowX: "auto", maxWidth: "85vw" }}>
            {soldOutDates.concat(storeHours).map((o, idx) => {
              const dt = moment(o);
              return (
                <Box
                  sx={{
                    borderRadius: "4px",
                    padding: "7px",
                    minWidth: "100px",
                    textAlign: "center",
                    backgroundColor: "#fdeded",
                    textDecoration: "line-through"
                  }}
                >
                  <Typography variant="body1">{o}</Typography>
                  {/* <Typography variant="overline" color="textSecondary" display="block">
              {dt.format("ddd")}
            </Typography> */}
                </Box>
              );
            })}
          </Box>
        </Box>
      );
    }
  }

  return (
    <Box>
      <Box my={2}>{alert}</Box>
      {blockedDates}
    </Box>
  );
}
